<template>
    <div>
        <Modal :is_show="is_show" @click-bg="close()" class="add-creator-modal add-custom-modal edit-program-set-pop">
            <header class="edit_program_header">
                {{ heading }}
                <i @click="close()"><svg-icon name="close" /></i>
            </header>

            <Scrollbar class="edit-scroll-list" :show_bar="true" v-if="handle_data.client_view">
                <div class="edit_program_body">
                    <div class="box question-templeat">
                        <div class="line">
                            <div class="name">Question: <span style="color: var(--alert);">*</span></div>
                        </div>
                        <Field :type="'text'" :k="handle_data.client_view.input_type" :placeholder="handle_data.plac" 
                            @update="update" :had_value="handle_data.client_view.label" :max_value="handle_data.max_title" :spec="'title'"/>
                        
                        <!-- Option -->   
                        <div v-if="had_opt" :key="opt_key_refrash">
                            <div class="line opt-line">
                                <div class="name">Option ({{handle_data.client_view.input_option.length}}/{{ handle_data.max_value }})</div>   
                            </div>
                            <div class="option-box" v-for="(v, k) in handle_data.client_view.input_option" :key="k" >
                                <Field 
                                :type="'text'" :k="k" :placeholder="'Option ' + (k+1)" 
                                @update="update" :had_value="v.name" :max_value="handle_data.max_title"/>
                                <svg-icon name="stop" @click="delOption(k)"/>
                            </div>
                        </div> 
                     

                        <div class="do-thing-box">
                            <Button v-if="had_opt" :style="'border'" size="24" :border_r="4" @click="addOption" :flex="true" :is_disabled="handle_data.client_view.input_option.length>=handle_data.max_value"><svg-icon
                            name="plus" />New option</Button>
                            <div class="req-box" @click.native="handle_data.client_view.is_required= handle_data.client_view.is_required ? false : true">
                                <Checkbox :checked="handle_data.client_view.is_required" />
                                Required
                            </div>
                        </div>
                    </div>
                </div>
            </Scrollbar>

            <!-- save -->
            <div class="btn-box" v-if="handle_data.client_view">
                <div v-if="is_can_delete" class="del red" style="padding: 0 12px;" @click="is_show_alert_modal = true">Delete</div>
                <Button class="save-btn" size="40" color="dark-blue" :border_r="6" @click="save" :is_disabled="!handle_data.client_view.label || (had_opt && handle_data.client_view.input_option.length===0) || (had_opt && handle_data.client_view.input_option.length==1 && handle_data.client_view.input_option[0].name ==='')">
                    Save
                </Button>
            </div>
        </Modal>


        <Modal :is_show="is_show_alert_modal" class="alert-modal" @click-bg="is_show_alert_modal = false">
            <div class="box">
                <header class="delete-header">Remove this question?</header>
                <p>Removing this question will mark any
                    previously collected responses as
                    removed. The question will no longer
                    appear in new responses after this
                    change. Do you want to proceed?</p>
                <div class="btns">
                    <Button type="button" :border_r="6" color="white" size="32" @click.native="is_show_alert_modal = false;">No</Button>
                    <Button type="button" :border_r="6" color="dark-blue" size="32"
                        @click.native="is_show_alert_modal = false; $emit('del',{data:handle_data,type:'custom_question'});">Confirm</Button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import Button from '@/components/ui/Button.vue';
import Modal from '@/components/ui/Modal.vue';
import Loading from '@/components/ui/Loading.vue';
import NoData from '@/components/creator/NoData.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import Switch from '@/components/ui/Switch.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import Field from '@/components/ui/Field.vue';

export default {
    name: 'ProgramForm-pae',
    emits: ['close','save','del'],

    data() {
        return {
            handle_data: {},
            heading: '',
            default_option:["Yes","No","Unsure"],
            is_show_alert_modal:false,
            opt_key_refrash:0,
        }
    },

    props: {
        is_show: {
            type: Boolean,
            default: true,
        },
        title:{
            type: String,
            default: '',
        },
        data: {
            type: Object,
            default: {}
        },
        is_edit: {
            type: Boolean,
            default: false,
        },
        is_can_delete: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        had_opt(){
            return this.handle_data.id===0||this.handle_data.id===1;
        }
    },

    components: {
        Scrollbar,
        Button,
        Modal,
        NoData,
        Loading,
        Dropdown,
        Switch,
        Checkbox,
        Field,
    },

    watch: {

    },

    methods: {
        update(obj){
            if(obj.spec==='title'){
                this.handle_data.client_view.label=obj.val;
            }else{
                this.handle_data.client_view.input_option[obj.key]={name:obj.val, id:obj.key};
            }
        },

        save(){
            this.setDate();
            console.log('this.handle_data',this.handle_data)
            this.$emit('save',{data:this.handle_data,type:'custom_question'})
        },

        close(){
            this.$emit('close');
        },
        
        setDate() {
            if(this.had_opt){
                let arr=this.default_option.filter(value => value !== '');
                
                if(this.handle_data.client_view.input_option.length===0){
                    this.handle_data.client_view.input_option=arr.map((e,k)=>{
                        return{
                            name:e,
                            id:k,
                            is_checked:false,
                        }
                    })
                }
            }
        },

        addOption(){
            if(this.handle_data.client_view.input_option.length < this.handle_data.max_value){
                this.handle_data.client_view.input_option.push({ name:'', id:this.handle_data.client_view.input_option.length+1 });
                this.opt_key_refrash+=1;
            }
        },

        delOption(key){
            this.handle_data.client_view.input_option.splice(key, 1);
            this.opt_key_refrash+=1;
        }
    },


    mounted() {
        this.handle_data = this.data;
        if (this.is_can_delete) {
            this.heading = this.data.pop_title.replaceAll('Add ', 'Edit '); 
        } else {
            this.heading = this.data.pop_title; 
        }
        this.setDate();
    },

}
</script>

<style lang="scss">
@mixin flexCenter() {
    display: flex;
    align-items: center;
}

.add-custom-modal {

    .line{
        @include flexCenter();
    }

    .name {
        font: var(--font-med-16);
        @include flexCenter();
        flex: 1;
    }

    .ui-input{
        margin: 4px 0;
        flex:1;
    }

    .opt-line{
        margin-top:16px; 
    }

    .option-box{
        @include flexCenter();
        width: 100%;
        .ui-input{
            margin: 4px 0;
            flex:1;
        }

        .svg-icon{
            width: 16px;
            height: 16px;
            fill:var(--red);
            margin-left: 8px;
            cursor: pointer;
        }
    }

    .do-thing-box{
        @include flexCenter();
        margin-top: 4px;

        .ui-button{
            margin-right: 16px;
            padding: 3px 16px;
        }

        .req-box{
            @include flexCenter();
            .ui-checkbox{
                margin: unset;
            }
        }
    }
    
    .btn-box{
        @include flexCenter();
        justify-content: space-between;
        padding: 0 16px 16px;

        .del{
            margin-right: 16px;
            color:var(--red);
            cursor: pointer;
        }

        .save-btn{
            margin-top: unset !important;
            width: 100%;
            text-align: center;
        }
    }
    
}
</style>